module.exports = __webpack_public_path__ + "static/animated-illustration-1-4b61d2723cbf25c0d9cb9a9711444902.gif";